import styled, { css } from 'styled-components';
import Icon from '../../../../icon';
import { LinkLabel } from '../../../../link';
import { stylePropertiesToCss } from '../../../../../design-tokens/style-mixins';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * PanelLinksContainer
 */
export const panelLinksContainerStyles = () => css `
	counter-reset: topX;
	margin: 0;
	max-width: none;
	padding: 0;
`;
export const PanelLinksContainer = styled.ul `
	${panelLinksContainerStyles}
`;
export const panelLinkStyles = ({ theme, $numbered }) => css `
	border-top: ${pxToRem(theme.borderWidth[2])} solid ${theme.colors.light.borderPanelInformative};
	display: flex;
	padding: ${pxToRem(theme.spacing[200])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		padding: ${pxToRem(theme.spacing[200])} ${pxToRem(theme.spacing[300])};
	}

	${LinkLabel} {
		display: flex;
		align-items: flex-end;
	}

	${$numbered &&
    css `
		&::before {
			counter-increment: topX;
			content: counter(topX) '.\\00a0';
			display: inline-block;

			${stylePropertiesToCss(theme.typography.numbersPricesAndUsPs['200Number'])}
		}
	`}
`;
export const PanelLink = styled.li `
	${panelLinkStyles}
`;
/**
 * Panel link icon
 */
export const panelLinkIconStyles = ({ theme }) => css `
	margin-right: ${pxToRem(theme.spacing['200'])};
`;
export const PanelLinkIcon = styled(Icon) `
	${panelLinkIconStyles}
`;
